import React from 'react';
import ReactDOM from 'react-dom/client';
import "./style/global.css";
import Rotas from './rotas';
import Rodape from './components/footer/footer';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<>
   <Rotas/>
   <Rodape/>
  </>
);


